module.exports = __webpack_public_path__ + "img/couples-037.71b8830a.jpg";